module.exports = __webpack_public_path__ + "media/images/suppliers/abclonal-f36f46c913bb67cc47af2466774fdb72.png";